import styled from 'styled-components';
import { TextField, Button, Container } from '@mui/material';

export const FormContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* background-color: #f5f5f5; */
`;

export const Form = styled.form`
  width: 100%;
  max-width: 100%;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const InputField = styled(TextField)`
  margin-bottom: 16px !important;
`;

export const SubmitButton = styled(Button)`
  margin-top: 16px !important;
`;
